import { render, staticRenderFns } from "./TableOfProducts.vue?vue&type=template&id=fcfe21de&"
import script from "./TableOfProducts.vue?vue&type=script&lang=js&"
export * from "./TableOfProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports